module.exports = __webpack_public_path__ + "img/avatar-05.Dmbw8z7l.62b0c33a.jpg";